import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    overflow: 'hidden',
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
  },
  div: {
    color: theme.colors.text.primary,
    padding: '6px 0px',
  },
  properties: {
    color: theme.colors.text.secondary,
    backgroundColor:
      window.sessionStorage.getItem('appState') !== 'superUser'
        ? theme.colors.gray
        : `${theme.colors.lightGray} !important`,
  },
  pannelContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '-35px',
  },
  pannelTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: theme.colors.text.primary,
  },
  removeIcon: {
    color: theme.colors.red,
  },
  typeIcon: {
    color: theme.colors.secondary,
    fontSize: 18,
    margin: '0 2px',
  },
  buttons: {
    border: 'none',
    margin: ' 10px 10px 0 10px',
  },
  red: {
    backgroundColor: `${theme.colors.red} !important`,
    borderColor: `${theme.colors.red} !important`,

    ':hover': {
      backgroundColor: `${theme.colors.highlightedRed} !important`,
      borderColor: `${theme.colors.highlightedRed} !important`,
    },

    ':focus': {
      backgroundColor: `${theme.colors.red} !important`,
      borderColor: `${theme.colors.red} !important`,
    },
  },
  green: {
    backgroundColor: `${theme.colors.green} !important`,
    borderColor: `${theme.colors.green} !important`,

    ':hover': {
      backgroundColor: `${theme.colors.highlightedGreen} !important`,
      borderColor: `${theme.colors.highlightedGreen} !important`,
    },

    ':focus': {
      backgroundColor: `${theme.colors.green} !important`,
      borderColor: `${theme.colors.green} !important`,
    },
  },
  darkBlue: {
    backgroundColor: `${theme.colors.secondary} !important`,
    borderColor: `${theme.colors.secondary} !important`,

    ':hover': {
      backgroundColor: `${theme.colors.highlightedSecondary} !important`,
      borderColor: `${theme.colors.highlightedSecondary} !important`,
    },

    ':focus': {
      backgroundColor: `${theme.colors.highlightedSecondary} !important`,
      borderColor: `${theme.colors.secondary} !important`,
    },
  },
  blue: {
    backgroundColor: `${theme.colors.primary} !important`,
    borderColor: `${theme.colors.primary} !important`,

    ':hover': {
      backgroundColor: `${theme.colors.highlightedPrimary} !important`,
      borderColor: `${theme.colors.highlightedPrimary} !important`,
    },

    ':focus': {
      backgroundColor: `${theme.colors.primary} !important`,
      borderColor: `${theme.colors.primary} !important`,
    },
  },
  yellow: {
    backgroundColor: `${theme.colors.yellow} !important`,
    borderColor: `${theme.colors.yellow} !important`,

    ':hover': {
      backgroundColor: `${theme.colors.highlightedYellow} !important`,
      borderColor: `${theme.colors.highlightedYellow} !important`,
    },
    ':focus': {
      backgroundColor: `${theme.colors.yellow} !important`,
      borderColor: `${theme.colors.yellow} !important`,
    },
  },
  alignCenterWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px 20px',
  },
  tagPoint: {
    width: 15,
    height: 15,
    borderRadius: 10,
  },
  lightGray: {
    backgroundColor: theme.colors.lightGray,
  },
  gray: {
    backgroundColor: theme.colors.gray,
  },
  black: {
    backgroundColor: theme.colors.darkGray,
  },
  transparent: {
    border: `1px solid ${theme.colors.lightGray}`,
  },
  orange: {
    backgroundColor: '#FFA500',
  },
  purple: {
    backgroundColor: '#800080',
  },
  grey: {
    backgroundColor: '#808080',
  },
});
